import React, { createContext, ReactNode, useContext } from 'react'
import { noop } from 'lodash'
import { useValidationForm } from 'utils/hooks/useValidationForm'

export interface IValidationFormErrorState {
  errors?: string
  setHasErrors: (value: boolean) => void
}

/**
 * Init the context
 */
export const validationFormDefaultState: IValidationFormErrorState = {
  errors: '',
  setHasErrors: noop,
}

// Creates the context object that we'll pass into components
export const ValidationFormContext = createContext<IValidationFormErrorState>(
  validationFormDefaultState
)

/**
 * Provide default Provider state component to wrap around app
 */
export const ValidationFormProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const state = useValidationForm()
  return <ValidationFormContext.Provider value={state}>{children}</ValidationFormContext.Provider>
}

export const useValidationFormContext = () => useContext(ValidationFormContext)
